// src/CustomRoleDialog.js
import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Box, Typography, FormControlLabel, Checkbox, Grid } from '@mui/material';
import api from './apiClient';

function CustomRoleDialog({ open, onClose, onSave, currentUserId }) {
  const [name, setName] = useState('');
  const [permissions, setPermissions] = useState({
    view_tasks: false,
    edit_tasks: false,
    delete_tasks: false,
    manage_users: false,
    // Add more permissions as needed
  });

  const handleToggle = (perm) => {
    setPermissions(prev => ({ ...prev, [perm]: !prev[perm] }));
  };

  const handleSave = async () => {
    try {
      await api.post('/api/custom-roles', { name, permissions, user_id: currentUserId });
      onSave();
      onClose();
    } catch (err) {
      console.error('Create custom role error:', err);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Create Custom Role</DialogTitle>
      <DialogContent>
        <TextField label="Role Name" value={name} onChange={(e) => setName(e.target.value)} fullWidth sx={{ mb: 2 }} />
        <Typography variant="h6">Permissions</Typography>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <FormControlLabel control={<Checkbox checked={permissions.view_tasks} onChange={() => handleToggle('view_tasks')} />} label="View Tasks" />
            <FormControlLabel control={<Checkbox checked={permissions.edit_tasks} onChange={() => handleToggle('edit_tasks')} />} label="Edit Tasks" />
          </Grid>
          <Grid item xs={6}>
            <FormControlLabel control={<Checkbox checked={permissions.delete_tasks} onChange={() => handleToggle('delete_tasks')} />} label="Delete Tasks" />
            <FormControlLabel control={<Checkbox checked={permissions.manage_users} onChange={() => handleToggle('manage_users')} />} label="Manage Users" />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave} variant="contained">Save</Button>
      </DialogActions>
    </Dialog>
  );
}

export default CustomRoleDialog;